"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.setMoveHidePinListener = exports.removeMarker = exports.createMarker = exports.createMap = void 0;
var sleep_1 = require("../common/utils/sleep");
var getId_1 = require("../renderer/getId");
var debounce_1 = require("../common/utils/debounce");
var Camera_1 = require("../renderer/Camera");
var roadStyle = require("./style.road.json");
var buildingStyle = require("./style.building.json");
var createMap = function (id, camera, newMinZoom, gestureHandling) {
    if (gestureHandling === void 0) { gestureHandling = 'greedy'; }
    var _a = camera || Camera_1.defaultCamera, center = _a.center, zoom = _a.zoom;
    var minZoom = newMinZoom || 11;
    var maxZoom = 21;
    var map = new google.maps.Map(document.getElementById(id), {
        center: center, zoom: zoom, minZoom: minZoom, maxZoom: maxZoom, gestureHandling: gestureHandling,
        disableDefaultUI: true,
        clickableIcons: false,
        styles: getMapStyle(zoom)
    });
    if (typeof window !== 'undefined') {
        if (typeof window.googlemap === 'undefined') {
            window.googlemap = {};
        }
        window.googlemap[id] = map;
    }
    return new Promise(function (res) {
        google.maps.event.addListenerOnce(map, 'idle', function () {
            res(map);
        });
    });
};
exports.createMap = createMap;
var getMapStyle = function (zoom) {
    return zoom > 18 ? buildingStyle : roadStyle;
};
var setMapStyle = function (map, styles) {
    map.setOptions({ styles: styles });
};
var createMarker = function (markerStore, map, pin) {
    return new Promise(function (res) {
        var id = getId_1.getMarkerId(pin);
        if (window.PinOverlay) {
            var PinOverlay = window.PinOverlay;
            var pinOverlay_1 = new PinOverlay(pin.lat, pin.lng, pin.noCluster || pin.popupActive ? 2 : 0, function () {
                markerStore.add(id, pinOverlay_1);
                res(pinOverlay_1);
            });
            pinOverlay_1.setMap(map);
        }
    });
};
exports.createMarker = createMarker;
var removeMarker = function (markerStore, pin) { return __awaiter(void 0, void 0, void 0, function () {
    var id, pinOverlay;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                id = getId_1.getMarkerId(pin);
                pinOverlay = markerStore.get(id);
                if (!pinOverlay) return [3 /*break*/, 2];
                pinOverlay.setMap(null);
                return [4 /*yield*/, sleep_1.sleep(200)];
            case 1:
                _a.sent();
                return [3 /*break*/, 3];
            case 2:
                console.log('no pin ref');
                _a.label = 3;
            case 3:
                markerStore.removeById(id);
                return [2 /*return*/];
        }
    });
}); };
exports.removeMarker = removeMarker;
var setMoveHidePinListener = function (map, onViewportChanged, onCancel) {
    var onViewportChangedCallback = function () {
        if (onViewportChanged) {
            var bound = map.getBounds();
            var ne = bound.getNorthEast();
            var sw = bound.getSouthWest();
            var zoom = map.getZoom();
            onViewportChanged({ lat: ne.lat(), lng: ne.lng() }, { lat: sw.lat(), lng: sw.lng() }, zoom);
        }
    };
    var onCancelCallback = function () { return onCancel(); };
    var VIEWPORT_CHANGED = 'viewport_changed';
    var CANCEL = 'cancel';
    var win = window;
    win.addEventListener(VIEWPORT_CHANGED, debounce_1.debounce(200, function () {
        onViewportChangedCallback();
    }));
    win.addEventListener(CANCEL, debounce_1.debounce(20, function () {
        onCancelCallback();
    }));
    google.maps.event.addListener(map, 'bounds_changed', function () {
        win.dispatchEvent(new Event(VIEWPORT_CHANGED));
    });
    google.maps.event.addListener(map, 'dragstart', function () {
        win.dispatchEvent(new Event(CANCEL));
    });
    google.maps.event.addListener(map, 'click', function () {
        onCancelCallback();
    });
    google.maps.event.addListener(map, 'zoom_changed', function () {
        var zoom = map.getZoom();
        if (zoom > 17) {
            setMapStyle(map, buildingStyle);
        }
        else {
            setMapStyle(map, roadStyle);
        }
        win.dispatchEvent(new Event(CANCEL));
    });
    return function () { return onViewportChangedCallback(); };
};
exports.setMoveHidePinListener = setMoveHidePinListener;
